module.exports = __webpack_public_path__ + "img/游戏制作交流群.fbc6061b.jpg";